/* global dataLayer */

import cartApi from '../shared/cart/cart_api'
export default {
  submitGooglePurchaseEvent() {
    if (!window.googleAnalytics4Id) { return }

    window.src=`https://www.googletagmanager.com/gtag/js?id=${window.googleAnalytics4Id}`
    window.dataLayer = window.dataLayer || []
    function gtag(){dataLayer.push(arguments)}
    gtag('js', new Date())

    gtag('config', window.googleAnalytics4Id)

    // COMMENT OUT GTAG ABOVE AND UNCOMMENT GTAG BELOW TO DEBUG, THEN VISIT
    // https://analytics.google.com/analytics/web/#/a92751600p326528897/admin/debugview/overview
    // gtag('config', window.googleAnalytics4Id,{ 'debug_mode': true })

    cartApi.getFinishedOrder().then(order => {
      gtag('event', 'purchase', {
        // This purchase event uses a different transaction ID
        // from the previous purchase event so Analytics
        // doesn't deduplicate the events.
        // Learn more: https://support.google.com/analytics/answer/12313109
        transaction_id: order.id,
        order_id: order.id,
        total: order.dollarized_usd_total,
        tax: order.object_tax,
        protect_group_amount: order.dollarized_usd_protect_group_amount,
        currency: order.currency,
        items:
              order.items.map(item => {
                return {
                  item_id: item.id,
                  item_name: item.display_name,
                  price: item.usd_total,
                  quantity: item.quantity,
                  room_quantity: item.room_quantity
                }
              })

      })
    })
  }
}